import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    Output,
    EventEmitter
} from '@angular/core';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store/index';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { BookedTrip, Passenger } from '@ibe/models';
import { Stopover } from '@ibe/store/states/mini-ibe.indra.state';
import { BookingStep } from '@ibe/models/ui';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import * as CalendarActions from '@ibe/store/actions/calendar.actions';
import { ModalService } from '@ibe/services/ui';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import { BookingType } from '@ibe.models/booked-trip.model.lib';
import {
    LOCAL_STORAGE_VAR_KEY_ROUTE_NAME,
	LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT,
    TRIP_TYPE_MULTICITY_CODE,
} from '@ibe.config';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as FlightInformationActions from '@ibe/store/actions/flight-information.indra.actions'
import * as OutboundFlightInformationActions from '@ibe/store/actions/outbound-flight-information.indra.actions'
import * as InboundFlightInformationActions from '@ibe/store/actions/inbound-flight-information.indra.actions'

enum steps {
    'dates' = 1,
    'flights',
    'review',
    'extras',
    'payment'
};

enum stepsForMCOrStopover {
    'flights' = 1,
    'review',
    'payment'
};

@Component({
    selector: 'app-top-menu-bar',
    templateUrl: './top-menu-bar.indra.component.html',
    styleUrls: ['./top-menu-bar.indra.component.scss']
})
export class INDRATopMenuBarComponent implements OnInit, OnDestroy {
    @Input() isBack: boolean = true;
    @Input() returnToSearch: boolean = false;

    @Output() backPage = new EventEmitter<string>();
    @Output() refresh = new EventEmitter();
	@Output() newSearch = new EventEmitter();


    private bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);

    isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
    isCorporate: boolean;

    stopovers$: Observable<Array<Stopover>> = this.store.select(fromStore.getMiniIBEStopovers);
    isStopover: boolean = false;

    booking_type$: Observable<BookingType> = this.store.select(fromStore.getSelectedBookingType);

    bookingSteps$: Observable<Array<BookingStep>> = this.store.select(fromStore.getSelectedBookingSteps);
    bookingStepsValue: Array<BookingStep>;
    bookingSteps: Array<BookingStep> = [];

    confirmModalCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
    confirmModalCallback = '';

    current_page$: Observable<any> = this.store.select(fromStore.getSelectedBookingCurrentPage);
    current_page: string;

    timeToThink_to_booking$: Observable<Object> = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
    isTTTBookingPayment: boolean = false;

    actionsOpen = false;
    booking: BookedTrip;

    IsMulticity = false;

    currentStep: number;

    isAlive = true;
    menuItems = [];

    constructor(
        protected sidebarService: SidebarService,
        private store: Store<fromStore.State>,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: ModalService
    ) {
		router.events
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((event: NavigationStart) => {
				if (event.navigationTrigger === 'popstate') {
					if (!this.isBack) {
						const returnRef = '/' + this.router.url.split('/')[1];
						this.sidebarService.close();
						this.store.dispatch(new MiniIBEActions.Reset());
						this.store.dispatch(new BookingStepsActions.ResetAction());
						this.router.navigate([returnRef]); 
					} else {
						this.sidebarService.close();
						this.INDRA_handleBackButton();
					}
				}
			});
    }
    ngOnDestroy(): void {
        window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
        this.isAlive = false;
    }

    ngOnInit() {
        window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));

        this.timeToThink_to_booking$.pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.isTTTBookingPayment = true;
                }
            });


        this.booking_type$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.IsMulticity = value == TRIP_TYPE_MULTICITY_CODE;
            });


        this.bookedTrip$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.booking = value;
                }
            });

        this.isCorporate$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(
                value => {
                    this.isCorporate = value;
                });

        this.stopovers$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.isStopover = value.length > 0;
                }
            });

        this.confirmModalCallback$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.confirmModalCallback = value;
                }
            });

        this.current_page$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.current_page = value;
            });

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.bookingStepsValue = value);

        this.currentStep = this.INDRA_getStep(this.router.url);

        this.menuItems = this.INDRA_menuItems();
    }

    INDRA_getStep(url: string): any {
        const isMultiOrStop = this.IsMulticity || this.isStopover;
        const stepsToUse = isMultiOrStop ? stepsForMCOrStopover : steps;
    
        if (url.includes('/dates') && !isMultiOrStop) return steps.dates;
        if (url.includes('/flights')) return stepsToUse.flights;
        if (url.includes('/review-your-trip')) return stepsToUse.review;
        if (url.includes('/extras-to-your-trip')) {
            return isMultiOrStop ? stepsToUse.review : steps.extras;
        }
        if (url.includes('/payment')) return stepsToUse.payment;
    }

    INDRA_menuItems() {
        let menuItems = [];
        const MCorStopover = this.IsMulticity || this.isStopover;

        if (this.INDRA_showDate && !MCorStopover) {
            menuItems.push({
                id: 'menu_btn_dates',
                translationKey: 'header.text.dates',
            });
        }

        const menuItemsToAdd = [
            {
                id: 'menu_btn_flights',
                translationKey: 'header.text.flights',
            },
            {
                id: 'menu_btn_review',
                translationKey: 'header.text.review',
            },
            ...(MCorStopover ? [] : [{
                id: 'menu_btn_extras',
                translationKey: 'header.text.extras',
            }]),
            {
                id: 'menu_btn_payment',
                translationKey: 'header.text.payment',
            }
        ];
            
        menuItems.push(...menuItemsToAdd);

        return menuItems;
    }

    INDRA_handleActionBtn(id: string) {

        let step = this.INDRA_getStepbyId(id);
        if (this.IsMulticity || this.isStopover) {
            const stepsToUse = stepsForMCOrStopover;
            switch (step) {                
                case (stepsToUse.flights): {//Heading to Flights from...
                    if (this.currentStep >= stepsToUse.review) {
                        this.store.dispatch(new FlightInformationActions.ResetAction);
                        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        if (this.returnToSearch && this.currentStep == stepsToUse.review) {
                            this.newSearch.emit()
                        } else {
                            this.backPage.emit('flights');
                        }
                        //this.INDRA_handleReviewBack2Flights();
                    }
                    break;
                };
                case (stepsToUse.review): {//Heading to Review from...
                    if (this.currentStep >= stepsToUse.review) {
                        sessionStorage.setItem('previousStep', this.current_page);
                        this.router.navigate(['/booking/review-your-trip']);
                    }
                    break;
                };
                default: {
                    this.router.navigate(['/booking/']); break;
                };
            }
        } else {
            const stepsToUse = steps;
            switch (step) {
                case (stepsToUse.dates): {//Heading to Dates from...
    
                    if (this.IsMulticity || this.isStopover) {
                        this.store.dispatch(new FlightInformationActions.ResetAction);
                        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        this.router.navigate(['/booking']);
    
                    }
                    else if (this.currentStep == stepsToUse.flights) {
                        this.store.dispatch(new FlightInformationActions.ResetAction);
                        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        this.router.navigate(['/booking/dates'], { queryParams: { confirm: 'flights' } });
    
                    }
                    else if (this.currentStep >= stepsToUse.review) {
                        this.store.dispatch(new FlightInformationActions.ResetAction);
                        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        this.INDRA_handleReviewBack2Dates();
                    }
                    break;
                };
                case (stepsToUse.flights): {//Heading to Flights from...
                    if (this.currentStep >= stepsToUse.review) {
                        this.store.dispatch(new FlightInformationActions.ResetAction);
                        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        if (this.returnToSearch && this.currentStep == stepsToUse.review) {
                            this.newSearch.emit()
                        } else {
                            this.backPage.emit('flights');
                        }
                        //this.INDRA_handleReviewBack2Flights();
                    }
                    break;
                };
                case (stepsToUse.review): {//Heading to Review from...
                    if (this.currentStep >= steps.extras) {
                        sessionStorage.setItem('previousStep', this.current_page);
                        this.router.navigate(['/booking/review-your-trip']);
                    }
                    break;
                };
                case (steps.extras): {//Heading to Extras from...
                    if (!this.isTTTBookingPayment) {
                        this.router.navigate(['/booking/extras-to-your-trip']);
                    } else {
                        this.router.navigate(['/booking/time-to-think']);
                    }
                    break;
                };
                default: {
                    this.router.navigate(['/booking/']); break;
                };
            }
        }
    }

    INDRA_buttonStyle(id: string) {

        let step = this.INDRA_getStepbyId(id);

        let classes: string[] = [];

        if(this.currentStep < step) classes.push('disable');
        if(this.currentStep == step) classes.push('is-selected');
        
        return classes;
    }

    INDRA_getStepbyId(id: string) {
        let step;
        if (this.IsMulticity || this.isStopover) {
            const stepsToUse = stepsForMCOrStopover;
            step = stepsToUse.flights;
            switch (id) {
                case 'menu_btn_flights': {
                    step = stepsToUse.flights;
                    break;
                }
                case 'menu_btn_review': {
                    step = stepsToUse.review;
                    break;
                }
                case 'menu_btn_payment': {
                    step = stepsToUse.payment;
                    break;
                }
                default: {
                    step = stepsToUse.flights;
                    break;
                }
            };
        } else {
            const stepsToUse = steps;
            step = stepsToUse.dates;
            switch (id) {
                case 'menu_btn_dates': {
                    step = stepsToUse.dates;
                    break;
                }
                case 'menu_btn_flights': {
                    step = stepsToUse.flights;
                    break;
                }
                case 'menu_btn_review': {
                    step = stepsToUse.review;
                    break;
                }
                case 'menu_btn_extras': {
                    step = steps.extras;
                    break;
                }
                case 'menu_btn_payment': {
                    step = stepsToUse.payment;
                    break;
                }
                default: {
                    step = stepsToUse.dates;
                    break;
                }
            };
        }
        return step;
    }

    INDRA_getIdBtStep(currentStep) {
        let id = 'menu_btn_dates';

        switch (currentStep) {
            case steps.dates: {
                id = 'menu_btn_dates';
                break;
            }
            case steps.flights: {
                id = 'menu_btn_flights';
                break;
            }
            case steps.review: {
                id = 'menu_btn_review';
                break;
            }
            case steps.extras: {
                id = 'menu_btn_extras';
                break;
            }
            case steps.payment: {
                id = 'menu_btn_payment';
                break;
            }
            default: {
                id = 'menu_btn_dates';
                break;
            }
        };

        return id;
    }

    INDRA_handleReviewBack2Dates() {
        this.store.dispatch(new ConfirmModalActions.PutTitle('Back to dates selection'));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg('If you choose to continue, you will loose the flight(s) you have selected. You will have to select all flights again. Are you sure you want to leave this page?'));
        this.store.dispatch(new ConfirmModalActions.PutCancelLabel('Don´t leave this page'));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel('Choose dates again'));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();

        this.modalService.isOpen
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (!value) {
                    if (this.confirmModalCallback === 'ok') {
                        this.router.navigate(['/booking/dates'], { queryParams: { confirm: 'flights' } });
                    }
                }
            });
    }

    INDRA_handleReviewBack2Flights() {
        this.store.dispatch(new ConfirmModalActions.PutTitle('Back to flight selection'));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg('If you choose to continue, you will loose the flight(s) you have selected. You will have to select all flights again. Are you sure you want to leave this page?'));
        this.store.dispatch(new ConfirmModalActions.PutCancelLabel('Don´t leave this page'));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel('Choose flights again'));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();

        this.modalService.isOpen
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (!value) {
                    if (this.confirmModalCallback === 'ok') {
                        this.INDRA_clearBookedTrip();
                        this.store.dispatch(new AncillariesWithMilesActions.ResetAction());
                        this.store.dispatch(new ConfirmModalActions.ResetAction);
                        if (this.booking.stopover) {
                            this.router.navigate(['/booking/flights-stopover']);
                        } else {
                            if (this.booking.booking_type == 'M') {
                                this.router.navigate(['/booking/flights-multicity']);
                            } else {
                                this.router.navigate(['/booking/flights']);
                            }
                        }
                    }
                }
            });
    }

    INDRA_clearBookedTrip() {
        const auxArray: Array<BookingStep> = [];
        this.bookingSteps.forEach(step => { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });

        const booked_trips = Object.assign(new BookedTrip([], this.booking.pnr, this.booking.booking_type), this.booking, { is_time_to_think: false });
        booked_trips.emptyFlights();

        this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trips));
        this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));
    }

    INDRA_lockNextBtns(id: string): boolean {
        let step = this.INDRA_getStepbyId(id);
        return this.currentStep < step;
    }

    INDRA_showOrder(id: string): number{
        let step = this.INDRA_getStepbyId(id);

        return this.INDRA_showDate() ? step : step;
    }

    INDRA_showDate(){
        return !this.isCorporate && !this.isStopover && !this.IsMulticity;
    }

	/**
	 * Emit back event to parent
	 */
	INDRA_handleBackButton() {
        const currentStepId = this.INDRA_getIdBtStep(this.currentStep);
        if (currentStepId) {
            // Special case for flights to check if user didnt go through dates page
            if (currentStepId === 'menu_btn_flights') {
                this.bookingStepsValue.map(data => {
                    if (data.date_selected) {
                        this.INDRA_handleActionBtn('menu_btn_dates')
                    } else {
                        this.store.dispatch(new FlightInformationActions.ResetAction);
                        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        this.backPage.emit();
                    }
                });
            } else {
                const menuItems = this.INDRA_menuItems();
                const currentStepIndex = menuItems.findIndex(item => item.id === currentStepId);
    
                if (currentStepIndex > 0) {
                    const previousMenuItem = menuItems[currentStepIndex - 1];
    
                    if (previousMenuItem) {
                        this.INDRA_handleActionBtn(previousMenuItem.id);
                    }
                }
            }

        } else {
            if (this.returnToSearch) {
                this.newSearch.emit()
            } else {
                this.backPage.emit();
            }
        }
	}

    beforeUnloadHandler(event: BeforeUnloadEvent) {
		localStorage.setItem(LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT, 'true');
		localStorage.setItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME, this.router.url);
        this.sidebarService.close();
		this.refresh.emit()
	}
}
